import {business} from '@sail/icons/react/Icon';
import {Icon, view} from '@sail/ui';

export const CurrentMerchantSection = ({
  merchantName,
  merchantAvatar,
}: {
  merchantName: string;
  merchantAvatar?: string;
}) => {
  return (
    <view.div css={{stack: 'x', gap: 'small'}}>
      <view.div
        css={{
          stack: 'x',
          width: 'large',
          height: 'large',
          alignSelfY: 'center',
        }}
      >
        {merchantAvatar ? (
          <view.img
            data-testid="merchant-avatar"
            src={merchantAvatar}
            css={{
              width: 'fill',
              height: 'fill',
              borderRadius: '50%',
              border: '1px inset rgba(0, 0, 0, 0.15)',
            }}
          />
        ) : (
          <view.div
            css={{
              borderRadius: '50%',
              border: '1px inset rgba(0, 0, 0, 0.15)',
              width: 'fill',
              height: 'fill',
            }}
          >
            <Icon
              icon={business}
              css={{
                padding: 'xsmall',
                width: 'fill',
                height: 'fill',
              }}
            />
          </view.div>
        )}
      </view.div>

      <view.h3
        css={{
          margin: 0,
          font: 'heading.small',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}
        data-testid="merchant-name"
      >
        {merchantName}
      </view.h3>
    </view.div>
  );
};
